module.exports = __webpack_public_path__ + "static/media/gabriel_5.eccc6d13.png";